export const roles = {
  'student': 1023,
  'instructor': 1024,
  'editor': 1025,
  'admin': 1026
}